(() => {
  const root = document.querySelector('[data-personal-report]');
  const sample = root?.querySelector('[data-purchase-sample]');
  if (!sample || sample.dataset.ready) return;
  sample.dataset.ready = 'true';
  const disclosure = sample.querySelector('[data-sample-reader]');
  const opener = disclosure.querySelector('summary');
  const reading = disclosure.querySelector('[data-sample-reading]');
  if (typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
    const dialog = document.createElement('dialog');
    dialog.className = 'pr-sample-dialog';
    dialog.setAttribute('aria-labelledby', 'PersonalSampleTitle');
    dialog.setAttribute('scroll-lock', '');
    const toolbar = document.createElement('div');
    toolbar.className = 'pr-sample-toolbar';
    const label = document.createElement('strong');
    label.textContent = 'Sample report';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'pr-sample-close';
    close.textContent = 'Back to my report';
    toolbar.append(label, close);
    dialog.append(toolbar, reading);
    document.body.append(dialog);
    opener.setAttribute('aria-haspopup', 'dialog');
    opener.addEventListener('click', event => {
      event.preventDefault();
      dialog.showModal();
      dialog.scrollTop = 0;
      close.focus({preventScroll:true});
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener.focus({preventScroll:true}));
  }

  const download = sample.querySelector('[data-sample-download]');
  const status = sample.querySelector('[data-sample-download-status]');
  download.hidden = false;
  download.addEventListener('click', async () => {
    if (download.disabled) return;
    download.disabled = true;
    download.textContent = 'Preparing PDF…';
    status.textContent = '';
    try {
      const response = await fetch(sample.dataset.sampleDownloadUrl);
      if (!response.ok) throw new Error('Download unavailable');
      const payload = await response.json();
      if (payload.mime !== 'application/pdf' || typeof payload.base64 !== 'string') throw new Error('Invalid PDF');
      const bytes = Uint8Array.from(atob(payload.base64), c => c.charCodeAt(0));
      if (String.fromCharCode(...bytes.slice(0, 5)) !== '%PDF-') throw new Error('Invalid PDF');
      const url = URL.createObjectURL(new Blob([bytes], {type:'application/pdf'}));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'personal-reading-demonstration.pdf';
      document.body.append(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      status.textContent = 'PDF download started. You can also read the full sample above.';
    } catch {
      status.textContent = 'The PDF could not be downloaded. Please try again, or read the full sample above.';
    } finally {
      download.disabled = false;
      download.textContent = 'Download sample PDF';
    }
  });

  const form = root.querySelector('form');
  const excerpts = [...root.querySelectorAll('[data-sample-depth]')];
  function updateExcerpt() {
    const enhanced = root.querySelector('[data-enhanced-editions]');
    const depth = enhanced && !enhanced.hidden ? form?.querySelector('[name=personal_depth]:checked')?.value : null;
    excerpts.forEach(excerpt => { excerpt.hidden = !!depth && excerpt.dataset.sampleDepth !== depth; });
  }
  form?.addEventListener('change', updateExcerpt);
  updateExcerpt();
})();
